


































	import Vue from 'vue';
	import Component from 'vue-class-component';

	import BlocEnfantTemplate from '@/components/santeEnfant/template/BlocEnfantTemplate.vue';

	const Props = Vue.extend({
		props: {
			//date presumee grossesse
			enfants: {
				type: Array,
				default: () => []
			}
		}
	});

	@Component({
        components: {
			BlocEnfantTemplate
        }
    })
	export default class AccueilEnfants extends Props {

	}
